import React from 'react';
import schemaDentaire from '../../assets/img/schemaDentaire.png';
import { Button, Img, Text } from '../../Atoms';
import { Input } from '../../Molecules';
function TemplateSimulateurRembourcementScreen3(props) {
    return (
        <>
            <div className='step-3-container-simulateur-rembourse' >
                <div style={{ marginTop: '40px' }}>
                    <Input
                        inputLabel= {props.selectedActes.text === 'Orthodontie' ? 'Durée (en mois)' : 'Dent concernée (se référer au schema ci-contre)'}
                        placeholder=''
                        className='input-dent-simulateur-remboursement'
                        onChange={(e) => props.onChangeDentaireInput(e.target.value)}
                        value={props.dentaireInputValue} 
                    />
                    {props.selectedActes.text === 'Orthodontie' &&
                    <div className='margin-btn-radio-simulateur-remboursement-step3'>
                        <Text
                            text='Intervention de la Sécurité Sociale :'
                            className='btn-radio-simulateur-remboursement-label'
                        />
                        <div className='btn-radio-simulateur-remboursement-container'>
                            <div style={{ display: 'flex' }}>
                                <div 
                                className={props.interventionSecuriterSocial === true 
                                ? 'btn-selected-radio-simulateur-remboursement'
                                : 'btn-radio-simulateur-remboursement' }
                                onClick={() => props.onChangeBtnRadioStep2('interventionSecuriterSocial', true)}
                                ></div>
                                <span className="btn-radio-value-simulateur-remboursement"
                                onClick={() => props.onChangeBtnRadioStep2('interventionSecuriterSocial', true)}
                                >Oui</span>
                            </div>
                            <div style={{ display: 'flex' }}>
                                <div className={props.interventionSecuriterSocial === false 
                                ? 'btn-selected-radio-simulateur-remboursement'
                                : 'btn-radio-simulateur-remboursement' }
                                onClick={() => props.onChangeBtnRadioStep2('interventionSecuriterSocial', false)}
                                ></div>
                                <span className="btn-radio-value-simulateur-remboursement"
                                onClick={() => props.onChangeBtnRadioStep2('interventionSecuriterSocial', false)}
                                >Non</span>
                            </div>
                        </div>
                    </div>
                    }
                    <div className='btn-next-container-simulateur-remboursement display-web-simulateur-rembourse'>
                        <Button
                            text='Suivant'
                            className={'btn-next-simulateur-remboursement'}
                            onClick={() => props.nextStep(3)}
                        />
                    </div>
                </div>
                {props.selectedActes.text !== 'Orthodontie' &&
                    <div className='img-container-simulateur-remboursement'>
                        <Img src={schemaDentaire} className='img-simulateur-remboursement' />
                    </div>
                }
            </div>

            <div className='display-mobile-simulateur-rembourse btn-next-container-simulateur-remboursement '>
                <Button
                    text='Suivant'
                    className={'btn-next-simulateur-remboursement'}
                    onClick={() => props.nextStep(3)}
                />
            </div>
        </>

    );
}

export default TemplateSimulateurRembourcementScreen3;
